"use client";

import Image from "next/image";
// CMS-supplied hrefs are emitted verbatim - do NOT swap this for @repo/ui/navigation.
// The CMS localizes its own URLs (e.g. "cl/es/centro-de-ayuda/") and also returns
// external/relative ones, so prefixing here would double or corrupt the locale.
import Link from "next/link";

import type { IconTextCtaCard as IconTextCtaCardType } from "@repo/ui/types/cms";

export interface IconTextCtaCardProps {
  className?: string;
  item: IconTextCtaCardType;
}

export default function IconTextCtaCard({ item, className = "" }: Readonly<IconTextCtaCardProps>) {
  const { title, icon, cta_link } = item;

  return (
    <Link
      href={cta_link}
      className={`flex cursor-pointer items-center gap-3 rounded-md px-2 py-2 ${className}`}
    >
      <div className="bg-brand-blue-40 rounded-full p-3">
        <div className="relative h-5 w-5">
          {icon && <Image src={icon} alt={title || "icon"} fill className="object-contain" />}
        </div>
      </div>
      {title && <span className="text-brand-blue text-sm">{title}</span>}
    </Link>
  );
}
